import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { HostedField } from 'react-braintree-fields';
import { translate } from 'react-i18next';

export class PaymentCardFormField extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    type: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.state = { isValid: true };
  }

  handleValidityChange = result => {
    this.setState({ isValid: result.isValid });
  };

  render() {
    const classList = ['input'];

    if (!this.state.isValid) {
      classList.push('input--error');
    }

    return (
      <div className={classList.join(' ')}>
        <div className="label">
          {this.props.t(
            `paymentMethod.paymentCard.fields.${this.props.type}.label`
          )}
        </div>

        <label>
          <HostedField
            type={this.props.type}
            placeholder={this.props.t(
              `paymentMethod.paymentCard.fields.${this.props.type}.placeholder`
            )}
            onValidityChange={this.handleValidityChange}
          />
        </label>

        {!this.state.isValid && (
          <p className="input__error-message">
            {this.props.t(
              `paymentMethod.paymentCard.fields.${this.props.type}.invalid`
            )}
          </p>
        )}
      </div>
    );
  }
}

export default translate()(PaymentCardFormField);



// WEBPACK FOOTER //
// ./src/components/PaymentCardFormField/PaymentCardFormField.js